import React, { useState, useRef } from 'react';
import ReactDOM from "react-dom";
import Card from "../components/Card";
import SearchInput from "../components/datatable/SearchInput"
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import LoadingIndicator from "../components/datatable/LoadingIndicator";
import EmptyTable from "../components/datatable/EmptyTable";
import Button from "../components/Button";
import Filter from "../components/datatable/Filter";
import DuplicateJobModal from "../modals/DuplicateJobModal";

const FILTER_OPTIONS = {
    all: {
        name:   'All',
        value:  'all',
    },
    survey: {
        name:   'Survey',
        value:  'survey',
    },
    quote: {
        name:   'Quote',
        value:  'quote',
    },
    order: {
        name:   'Order',
        value:  'order',
    },
    manufacture: {
        name:   'Manufacture',
        value:  'manufacture',
    },
    archived: {
        name:   'Archived',
        value:  'archived',
    },
}

const JobDataTable = (props) => {
    const dataTableRef          = useRef(null);
    const [search, setSearch]   = useState("");
    const [filter, setFilter]   = useState(FILTER_OPTIONS.all.value);

    const [duplicateJobModal, setDuplicateJobModal] = useState(null);

    const renderNotes = (item) => {
        if (!item.notes || item.notes === "") {
            return "-";
        }

        return (
            <div className={"bespoke-tooltip"}>
                <div className={"tooltip-icon"}>
                    <i className="fa fa-sticky-note" />
                </div>
                <div className={"tooltip-text"}>
                    <span>{item.notes}</span>
                </div>
            </div>
        );
    }

    const renderRowButton = (job) => {
        return (
            <td>
                <div className={"d-flex justify-content-end align-content-center align-items-center"}>
                    {!!job.can && (job.can.update === true || job.can.delete === true) && (
                        <div className="dropdown">
                            <button
                                className="dropdown-toggle cursor-pointer text-eh-off-black h3"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <i className="far fa-ellipsis-h"/>
                            </button>
                            <div
                                className="dropdown-menu dropdown-menu-right p-0"
                                aria-labelledby="navbarDropdown"
                            >
                                {!!job.can.update === true && (
                                    <a className={"dropdown-item cursor-pointer"} href={route('job.show', {job: job.id})}>
                                        <span>View Job</span>
                                    </a>
                                )}
                                {can('create', 'job') && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => setDuplicateJobModal(job.id)}
                                    >
                                        <span>Duplicate Job</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </td>
        );
    }

    return (
        <React.Fragment>
            <Card title={"Jobs"} classes={"mh-100 border-0"}>
                <div className={"row m-0 mb-4 p-0 d-flex justify-content-xl-between"}>
                    <div className="col-12 col-xl-6 m-0 mb-3 mb-xl-0 p-0 pl-xl-2 order-xl-2">
                        <div className={"d-flex justify-content-between justify-content-xl-end align-items-center"}>
                            <Filter
                                label={"Status:"}
                                value={filter}
                                options={Object.values(FILTER_OPTIONS)}
                                name={"filter_status"}
                                onChange={(value) => setFilter(value)}
                                classes={""}
                            />
                            {can('viewAny', 'job') && (
                                <Button
                                    href={route('web-api.job.export', {
                                        searchTerm:     search,
                                        filterStatus:   filter,
                                    }).toString()}
                                    label={"Export"}
                                    classes={"ml-4 btn btn-outline-eh-off-black px-3 m-0"}
                                />
                            )}
                            {can('create', 'job') && (
                                <Button
                                    href={route('job.create', {origin: "index"}).toString()}
                                    label={"Create Job"}
                                    icon={"far fa-plus-circle"}
                                    classes={"ml-4 btn btn-eh-lilac px-3 m-0"}
                                />
                            )}
                        </div>
                    </div>
                    <div className="col-12 col-xl-4 m-0 p-0 pr-xl-2 order-xl-1 d-flex justify-content-start align-items-center">
                        <SearchInput
                            value={search}
                            classes={""}
                            placeholder={"Search..."}
                            onChange={(value) => setSearch(value)}
                        />
                    </div>
                </div>
                <div className={"row m-0 p-0"}>
                    <div className={"col-12 m-0 p-0"}>
                        <div className="data-table">
                            <AjaxDynamicDataTable
                                apiUrl={route('web-api.job.data-table').toString()}
                                loadingComponent={<LoadingIndicator />}
                                noDataComponent={<EmptyTable itemName="jobs" />}
                                fieldsToExclude={[
                                    'deleted_at',
                                    'can',
                                ]}
                                alwaysShowPagination
                                fieldMap={{
                                    id:             "Job Reference",
                                    name:           "Name",
                                    customer_name:  "Customer",
                                    site_name:      "Site",
                                    job_type_name:  "Type",
                                    contact_name:   "Contact",
                                    created_at:     "Created Date",
                                }}
                                fieldOrder={[
                                    'id',
                                    'name',
                                    'job_type_name',
                                    'customer_name',
                                    'site_name',
                                    'contact_name',
                                    'status',
                                    'id',
                                ]}
                                ref={dataTableRef}
                                defaultOrderByField={'id'}
                                defaultOrderByDirection={'asc'}
                                params={{
                                    searchTerm:     search,
                                    filterStatus:   filter
                                }}
                                buttons={(row) => renderRowButton(row)}
                                dataItemManipulator={(field, value, row) => {
                                    switch (field) {
                                        case 'notes':
                                            return renderNotes(row);
                                    }

                                    return <span>{value}</span>;
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Card>
            <DuplicateJobModal
                show={!!duplicateJobModal}
                jobId={!!duplicateJobModal ? duplicateJobModal : null}
                parentId={'jobs-datatable'}
                onCancel={() => setDuplicateJobModal(null)}
                onComplete={(job) => {
                    window.location.replace(route('job.show', {job: job}).toString());
                }}
            />
        </React.Fragment>
    );
}

export default JobDataTable;

const target = document.getElementById('jobs-datatable');
if (target) {
    ReactDOM.render(<JobDataTable />, target);
}
